import useSWR from 'swr';
import { useCustomerId } from '@hooks';

/**
 * SWR hook to fetch consumption by commerce
 */
const useConsumptionByCommerce = (params: Record<string, string>) => {
  const { customerId } = useCustomerId();
  const { data, isLoading, error, mutate } = useSWR(
    () => {
      const query = new URLSearchParams({ ...params, customerId: String(customerId) }).toString();
      return params?.product ? `/v2/client/consumption-by-commerce?${query}` : false;
    },
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error, mutate };
};

export default useConsumptionByCommerce;
